import { render, staticRenderFns } from "./loadList.vue?vue&type=template&id=6996abce&scoped=true&"
import script from "./loadList.vue?vue&type=script&lang=js&"
export * from "./loadList.vue?vue&type=script&lang=js&"
import style0 from "./loadList.vue?vue&type=style&index=0&id=6996abce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996abce",
  null
  
)

export default component.exports